import './menu_section.css';
import { MenuProduct } from '../MenuProduct/MenuProduct';

export const MenuSection = ({section}) => {
    return (
        <>
            {
                section.products && section.products.length > 0 && (
                    <div className='menu_category_container'  id={'menu_section_' + section.id}>
                        <h2 className='menu_category_title'>{section.name}</h2>
                        <p className='menu_category_description'>{section.description}</p>
                        <div className='menu_category_products'>
                            {
                                section.products && section.products.map(product => {
                                    return (
                                        <MenuProduct 
                                            key={"menu_product_" + product.id}
                                            product={product}
                                        />
                                    );
                                })
                            }
                        </div>
                    </div>
                )
            }
        </>
    );
}